/**
 * Resmi "YERLİ ÜRETİM" logosu — etikete koşullu basılan görsel.
 *
 * Gömülü tutuluyor çünkü logo firmaya göre değişmiyor; her kurulumda resim
 * kütüphanesine yüklenmesini beklemek gereksiz bir adım olurdu. Firma kendi
 * Yerli Malı Belgesi logosunu kullanmak isterse görsel elemanına kütüphaneden
 * başka bir resim seçebiliyor.
 *
 * Termal baskı notu: etiket 1 bit siyah-beyaz rasterlenir, gri ton yok.
 * Bu logo tek renk ve yüksek kontrastlı olduğu için sorunsuz basılıyor;
 * fotoğrafik görseller aynı şeyi yapmaz.
 */

// CRA görseli URL'e çevirir; aynı origin olduğu için html2canvas sorunsuz alır
import domesticLogoUrl from './yerli-uretim-logo.jpg';

/**
 * Şablonda saklanan değer. Gerçek URL yerine belirteç tutuluyor çünkü CRA
 * dosya adına içerik hash'i ekliyor (`yerli-uretim-logo.4f2a1c.jpg`); şablonlar
 * ise veritabanında kalıcı. Hash değişen bir derlemeden sonra kayıtlı URL
 * kırılırdı. Belirteç render anında çözülüyor (bkz. resolveImageSrc).
 */
export const DOMESTIC_LOGO_TOKEN = 'builtin:yerli-uretim';

/** Logonun derleme sonrası gerçek adresi */
export const DOMESTIC_LOGO_URL: string = domesticLogoUrl;

/** Logonun en/boy oranı (682×293 px) — eleman ölçülendirmesi buna uyar */
export const DOMESTIC_LOGO_ASPECT = 682 / 293;

/** Etikete eklenirken kullanılacak genişlik (mm) */
export const DOMESTIC_LOGO_WIDTH_MM = 22;

/** Verilen kaynak yerli üretim logosu mu — eleman listesinde ayırt etmek için */
export function isDomesticLogo(src?: string): boolean {
  return src === DOMESTIC_LOGO_TOKEN;
}

/**
 * Eleman kaynağını yüklenebilir bir adrese çevirir.
 * Gömülü görseller belirteçle saklandığı için her çizim yolunda (Konva tuvali,
 * HTML çıktısı, raster) bu fonksiyondan geçmeli.
 */
export function resolveImageSrc(src?: string | null): string {
  if (!src) return '';
  return src === DOMESTIC_LOGO_TOKEN ? DOMESTIC_LOGO_URL : src;
}
